const WIX_BLOCKS_SERVICE_APPS_BASE_URL =
  'https://blocks.wix.com/_api/wix-blocks-service/web/v1/apps/';

export const openBlocksEditor = (appDefId: string, widgetId: string) => {
  const url = new URL(`${WIX_BLOCKS_SERVICE_APPS_BASE_URL}${appDefId}/open`);

  url.searchParams.append('deeplink', `widgetPanel!${widgetId}`);

  window.open(url, '_blank');
};
